import React, { useContext } from 'react';
import { ThemeContext } from 'pages/_app';

export const UndoIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6 3.6V0L0 6L6 12V8C12 7.73 13.53 11.76 13.88 13.77C13.892 13.8315 13.925 13.8869 13.9733 13.9267C14.0217 13.9665 14.0824 13.9883 14.145 13.9883C14.2076 13.9883 14.2683 13.9665 14.3167 13.9267C14.365 13.8869 14.398 13.8315 14.41 13.77C17.08 2.86 6 3.6 6 3.6Z'
      fill='#3F3F46'
    />
  </svg>
);

export const RedoIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 3.6V0L16 6L10 12V8C4 7.73 2.47 11.76 2.12 13.77C2.108 13.8315 2.07501 13.8869 2.02666 13.9267C1.97832 13.9665 1.91763 13.9883 1.855 13.9883C1.79237 13.9883 1.73168 13.9665 1.68334 13.9267C1.63499 13.8869 1.602 13.8315 1.59 13.77C-1.08 2.86 10 3.6 10 3.6Z'
      fill='#3F3F46'
    />
  </svg>
);

export const MoveIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.78856 0.935388L5.00906 4.62035C5.00906 4.71957 4.97144 4.81513 4.90357 4.88771C4.83436 4.95497 4.74141 4.99276 4.64479 4.99276H4.62556L0.934697 4.78266C0.793935 4.77284 0.671233 4.68394 0.618405 4.55359C0.564409 4.42258 0.594499 4.27191 0.695139 4.1717L1.34693 3.52262L0.100823 2.29105C-0.0334176 2.14888 -0.0334176 1.9273 0.100823 1.78513L1.78795 0.105045C1.85348 0.0379555 1.94326 0 2.03721 0C2.134 0 2.22695 0.0376235 2.29599 0.105045L3.5326 1.34612L4.17489 0.697051C4.27821 0.601992 4.42632 0.572193 4.55856 0.620471C4.69414 0.66675 4.78622 0.79272 4.78856 0.935388ZM11.3553 4.99275H11.3745L15.0652 4.78266C15.206 4.77283 15.3288 4.68394 15.3817 4.55358C15.4356 4.42257 15.4056 4.2719 15.3049 4.17169L14.6531 3.52262L15.8994 2.29117C16.0336 2.149 16.0335 1.92725 15.8992 1.78508L14.2121 0.104998C14.0693 -0.0286823 13.8468 -0.0286823 13.7041 0.104998L12.4675 1.34608L11.8252 0.697004C11.7219 0.601945 11.5737 0.572146 11.4415 0.620424C11.3059 0.666703 11.2138 0.792728 11.2115 0.935396L10.991 4.62036C10.991 4.71958 11.0286 4.81514 11.0965 4.88772C11.1657 4.95498 11.2586 4.99275 11.3553 4.99275ZM4.6255 11.007L0.93481 11.2171C0.794048 11.2269 0.671178 11.3156 0.61835 11.446C0.564353 11.577 0.594445 11.7277 0.695085 11.8279L1.34688 12.477L0.100597 13.7084C-0.0336436 13.8506 -0.0334764 14.0723 0.100764 14.2145L1.78789 15.8946C1.85342 15.9617 1.9432 15.9996 2.03715 15.9996C2.13394 15.9996 2.22689 15.962 2.29593 15.8946L3.53254 14.6535L4.17483 15.3026C4.27815 15.3976 4.42627 15.4274 4.5585 15.3792C4.69408 15.3329 4.78619 15.2069 4.78853 15.0642L5.00903 11.3792C5.00903 11.28 4.97142 11.1844 4.90355 11.1119C4.83183 11.0364 4.72949 10.9978 4.6255 11.007ZM7.99993 5.04048C7.2117 5.04048 6.45591 5.35229 5.89853 5.90733C5.34119 6.46235 5.02805 7.21502 5.02805 7.99996C5.02805 8.7849 5.34117 9.53753 5.89853 10.0926C6.45587 10.6476 7.2117 10.9594 7.99993 10.9594C8.78816 10.9594 9.54395 10.6476 10.1013 10.0926C10.6587 9.53757 10.9718 8.7849 10.9718 7.99996C10.9718 7.21502 10.6587 6.46239 10.1013 5.90733C9.54399 5.35232 8.78816 5.04048 7.99993 5.04048ZM14.6531 12.4773L15.3049 11.8282C15.4055 11.728 15.4356 11.5774 15.3816 11.4464C15.3288 11.316 15.2061 11.2271 15.0653 11.2173L11.3746 11.0072C11.2706 10.998 11.1682 11.0368 11.0965 11.1122C11.0286 11.1848 10.991 11.2804 10.991 11.3796L11.2115 15.0646C11.2138 15.2072 11.3059 15.3333 11.4415 15.3795C11.5737 15.4278 11.7217 15.3982 11.825 15.3031L12.4673 14.654L13.7039 15.8951C13.7729 15.9625 13.8661 16 13.9629 16C14.0568 16 14.1466 15.962 14.2121 15.895L15.8992 14.2149C16.0335 14.0727 16.0335 13.8511 15.8992 13.709L14.6531 12.4773Z'
      fill='#3F3F46'
    />
  </svg>
);

export const RotateIcon = () => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.0942 10.9693L15.6251 10.7222C15.9195 9.85053 16.0704 8.93605 16.0704 8C16.0704 3.5891 12.7263 0 8.61603 0C7.63116 0 6.67352 0.203366 5.77011 0.604498C5.18775 0.863094 4.90962 1.58194 5.15055 2.20705C5.3915 2.83206 6.06129 3.1307 6.64387 2.87199C7.26925 2.59463 7.93284 2.45383 8.61612 2.45383C11.4658 2.45383 13.7838 4.94174 13.7838 8C13.7838 8.55738 13.703 9.10399 13.5518 9.63026L13.0908 9.3875C12.839 9.25454 12.5454 9.28755 12.3246 9.47281C12.1036 9.65794 12.003 9.95567 12.0617 10.25L12.6279 13.086C12.6748 13.3209 12.8169 13.5164 13.0178 13.6221C13.1193 13.6757 13.2285 13.7022 13.3375 13.7022C13.4445 13.7022 13.5515 13.6764 13.6512 13.6251L16.088 12.3705C16.3409 12.2406 16.4988 11.9727 16.5 11.6718C16.5012 11.3708 16.3459 11.1017 16.0942 10.9693ZM13.8722 9.79888C14.0447 9.21925 14.1319 8.61503 14.1319 8C14.1319 4.73591 11.6576 2.08075 8.61627 2.08075C7.88696 2.08075 7.17889 2.23087 6.51119 2.52739C6.10579 2.7068 5.63966 2.49958 5.47222 2.06477C5.30456 1.62995 5.49802 1.1294 5.90328 0.949605C6.7644 0.567356 7.67712 0.373591 8.61624 0.373591C12.5347 0.373591 15.7227 3.79506 15.7227 8.00017C15.7227 8.87898 15.5849 9.7386 15.3127 10.5578L13.9781 9.85493L13.8722 9.79888ZM15.9379 12.0339L13.5009 13.2887C13.396 13.3429 13.2757 13.3423 13.1712 13.287C13.0666 13.2319 12.9925 13.1299 12.9682 13.0076L12.4019 10.1713C12.3708 10.0158 12.422 9.86464 12.5389 9.76682C12.6078 9.70905 12.688 9.67937 12.7696 9.67937C12.8262 9.67937 12.8835 9.69375 12.9378 9.72236L15.9408 11.304C16.0737 11.3743 16.1527 11.5108 16.1522 11.6697C16.1516 11.8289 16.0715 11.9651 15.9379 12.0339Z'
      fill='#3F3F46'
    />
    <path
      d='M11.4637 13.1284C11.1817 13.0029 10.8708 13.0026 10.5888 13.128C9.96341 13.4054 9.29972 13.5462 8.61628 13.5462C5.76678 13.5462 3.44858 11.0582 3.44858 7.99967C3.44858 7.59708 3.49199 7.19606 3.57272 6.80291L3.90929 6.98018C4.01185 7.03435 4.12135 7.06071 4.23022 7.06071C4.38821 7.06071 4.54471 7.00467 4.67553 6.89487C4.89651 6.70974 4.99734 6.41201 4.93868 6.11773L4.37245 3.28168C4.32557 3.04678 4.18346 2.85126 3.98257 2.7456C3.78155 2.63926 3.55075 2.6386 3.349 2.74254L0.911728 3.99706C0.659121 4.12695 0.501245 4.39488 0.500007 4.6958C0.498767 4.99645 0.654276 5.26571 0.906014 5.39839L1.47707 5.69904C1.26886 6.44275 1.16208 7.21563 1.16208 7.99965C1.16208 12.4109 4.50594 16 8.61617 16C9.60056 16 10.558 15.7966 11.4623 15.3955C12.0447 15.1368 12.3228 14.4181 12.0821 13.7929C11.9654 13.4898 11.7457 13.2541 11.4637 13.1284ZM0.847972 4.69775C0.848716 4.53857 0.928827 4.40282 1.06238 4.33387L3.49918 3.07908C3.55114 3.05233 3.60695 3.03902 3.6625 3.03902C3.71943 3.03902 3.7761 3.05299 3.82893 3.08081C3.93347 3.13591 4.00762 3.23786 4.03193 3.36017L4.59816 6.19635C4.62929 6.35181 4.57807 6.503 4.46125 6.60082C4.34431 6.69864 4.19525 6.71515 4.0622 6.64527L1.05917 5.06347C0.926106 4.99319 0.847225 4.85665 0.847972 4.69775ZM11.3294 15.0507C10.4676 15.433 9.55484 15.6268 8.61631 15.6268C4.69784 15.6268 1.50986 12.2053 1.50986 7.99983C1.50986 7.27302 1.60485 6.55618 1.79235 5.86555L3.24933 6.63282C3.15049 7.08069 3.10052 7.5397 3.10052 7.99967C3.10052 11.2638 5.57465 13.9193 8.61584 13.9193C9.34515 13.9193 10.0534 13.7691 10.7213 13.4726C10.9173 13.3852 11.1336 13.3852 11.33 13.473C11.5264 13.5605 11.679 13.7244 11.7601 13.9354C11.9278 14.3703 11.7345 14.8707 11.3294 15.0507Z'
      fill='#3F3F46'
    />
    <path
      d='M11.3294 15.0507C10.4676 15.433 9.55484 15.6268 8.61631 15.6268C4.69784 15.6268 1.50986 12.2053 1.50986 7.99983C1.50986 7.27302 1.60485 6.55618 1.79235 5.86555L3.24933 6.63282C3.15049 7.08069 3.10052 7.5397 3.10052 7.99967C3.10052 11.2638 5.57465 13.9193 8.61584 13.9193C9.34515 13.9193 10.0534 13.7691 10.7213 13.4726C10.9173 13.3852 11.1336 13.3852 11.33 13.473C11.5264 13.5605 11.679 13.7244 11.7601 13.9354C11.9278 14.3703 11.7345 14.8707 11.3294 15.0507Z'
      fill='#3F3F46'
    />
    <path
      d='M0.847972 4.69775C0.848716 4.53857 0.928827 4.40282 1.06238 4.33387L3.49918 3.07908C3.55114 3.05233 3.60695 3.03902 3.6625 3.03902C3.71943 3.03902 3.7761 3.05299 3.82893 3.08081C3.93347 3.13591 4.00762 3.23786 4.03193 3.36017L4.59816 6.19635C4.62929 6.35181 4.57807 6.503 4.46125 6.60082C4.34431 6.69864 4.19525 6.71515 4.0622 6.64527L1.05917 5.06347C0.926106 4.99319 0.847225 4.85665 0.847972 4.69775Z'
      fill='#3F3F46'
    />
    <path
      d='M13.8722 9.79888C14.0447 9.21925 14.1319 8.61503 14.1319 8C14.1319 4.73591 11.6576 2.08075 8.61627 2.08075C7.88696 2.08075 7.17889 2.23087 6.51119 2.52739C6.10579 2.7068 5.63966 2.49958 5.47222 2.06477C5.30456 1.62995 5.49802 1.1294 5.90328 0.949605C6.7644 0.567356 7.67712 0.373591 8.61624 0.373591C12.5347 0.373591 15.7227 3.79506 15.7227 8.00017C15.7227 8.87898 15.5849 9.7386 15.3127 10.5578L13.9781 9.85493L13.8722 9.79888Z'
      fill='#3F3F46'
    />
    <path
      d='M15.9379 12.0339L13.5009 13.2887C13.396 13.3429 13.2757 13.3423 13.1712 13.287C13.0666 13.2319 12.9925 13.1299 12.9682 13.0076L12.4019 10.1713C12.3708 10.0158 12.422 9.86464 12.5389 9.76682C12.6078 9.70905 12.688 9.67937 12.7696 9.67937C12.8262 9.67937 12.8835 9.69375 12.9378 9.72236L15.9408 11.304C16.0737 11.3743 16.1527 11.5108 16.1522 11.6697C16.1516 11.8289 16.0715 11.9651 15.9379 12.0339Z'
      fill='#3F3F46'
    />
  </svg>
);

export const ScaleIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.0855 6.53445L3.91621 7.09658L4.26579 7.22597L7.73241 8.50903L7.91639 8.57713C7.97127 8.59763 8.0308 8.59763 8.08568 8.57713L8.26589 8.51043L11.7325 7.22737L12.0859 7.09658L11.9166 6.53445L11.1569 6.81578L8.00112 7.98443L4.84384 6.81527L4.0855 6.53445Z'
      fill='#3F3F46'
    />
    <path
      d='M8.00616 5.03667C7.97533 5.03601 7.94473 5.04117 7.91556 5.05201L3.91537 6.53479C3.80656 6.57474 3.73287 6.68742 3.73227 6.81479V12.7394C3.73203 12.8676 3.80585 12.9815 3.91537 13.0215L7.91556 14.5021C7.97044 14.5224 8.02997 14.5226 8.08485 14.5022L12.085 13.0217C12.1937 12.9808 12.2667 12.867 12.2661 12.7394V6.81479C12.2659 6.68808 12.1931 6.57553 12.085 6.53479L8.08485 5.05201C8.05949 5.04262 8.03295 5.03746 8.00616 5.03667ZM8.00021 5.64681L11.1569 6.81578L11.7325 7.02893V7.22737V12.5273L8.26589 13.8111L8.00021 13.9095L7.73241 13.8104L4.26579 12.5273V7.22597V7.02926L4.84384 6.81527L8.00021 5.64681Z'
      fill='#3F3F46'
    />
    <path
      d='M7.73241 8.29566V8.50903V13.8104V14.2223H8.26589V13.8111V8.51043V8.29566H7.73241Z'
      fill='#3F3F46'
    />
    <path
      d='M12.2224 12.4832L11.9567 12.9971L13.7284 14.1322L13.9941 13.6205L12.2224 12.4832Z'
      fill='#3F3F46'
    />
    <path
      d='M14.6673 13.0367C13.934 13.0367 13.3326 13.7026 13.3326 14.5172C13.3326 15.3318 13.934 16 14.6673 16C15.4006 16 16 15.3318 16 14.5172C16 13.7026 15.4006 13.0367 14.6673 13.0367ZM14.6673 13.6293C15.1123 13.6293 15.4665 14.0228 15.4665 14.5172C15.4665 15.0116 15.1123 15.4073 14.6673 15.4073C14.2223 15.4073 13.8661 15.0116 13.8661 14.5172C13.8661 14.0228 14.2223 13.6293 14.6673 13.6293Z'
      fill='#3F3F46'
    />
    <path
      d='M3.86647 12.4832L2.09471 13.6203L2.36247 14.1321L4.13422 12.997L3.86647 12.4832Z'
      fill='#3F3F46'
    />
    <path
      d='M1.33269 13.0367C0.599433 13.0367 0 13.7026 0 14.5172C0 15.3318 0.599433 16 1.33269 16C2.06595 16 2.6674 15.3318 2.6674 14.5172C2.6674 13.7026 2.06595 13.0367 1.33269 13.0367ZM1.33269 13.6293C1.77773 13.6293 2.13392 14.0229 2.13392 14.5172C2.13392 15.0116 1.7777 15.4073 1.33269 15.4073C0.88766 15.4073 0.53348 15.0116 0.53348 14.5172C0.53348 14.0228 0.887782 13.6293 1.33269 13.6293Z'
      fill='#3F3F46'
    />
    <path
      d='M8.00078 0C7.26752 0 6.66809 0.668171 6.66809 1.48278C6.66809 2.29739 7.26752 2.96333 8.00078 2.96333C8.73404 2.96333 9.33347 2.29739 9.33347 1.48278C9.33347 0.668171 8.73404 0 8.00078 0ZM8.00078 0.592666C8.44581 0.592666 8.79999 0.988408 8.79999 1.48278C8.79999 1.97715 8.44569 2.37066 8.00078 2.37066C7.55575 2.37066 7.20157 1.97719 7.20157 1.48278C7.20157 0.988374 7.55587 0.592666 8.00078 0.592666Z'
      fill='#3F3F46'
    />
    <path
      d='M7.73241 2.66834V5.33418H8.26589V2.66834H7.73241Z'
      fill='#3F3F46'
    />
    <path
      d='M8.00078 0.592666C8.44581 0.592666 8.79999 0.988408 8.79999 1.48278C8.79999 1.97715 8.44569 2.37066 8.00078 2.37066C7.55575 2.37066 7.20157 1.97719 7.20157 1.48278C7.20157 0.988374 7.55587 0.592666 8.00078 0.592666Z'
      fill='#3F3F46'
    />
    <path
      d='M8.00112 7.98443L11.1569 6.81578L8.00021 5.64681L4.84384 6.81527L8.00112 7.98443Z'
      fill='#3F3F46'
    />
    <path
      d='M7.73241 8.50903L4.26579 7.22597V12.5273L7.73241 13.8104V8.50903Z'
      fill='#3F3F46'
    />
    <path
      d='M11.7325 7.22737L8.26589 8.51043V13.8111L11.7325 12.5273V7.22737Z'
      fill='#3F3F46'
    />
    <path
      d='M14.6673 13.6293C15.1123 13.6293 15.4665 14.0228 15.4665 14.5172C15.4665 15.0116 15.1123 15.4073 14.6673 15.4073C14.2223 15.4073 13.8661 15.0116 13.8661 14.5172C13.8661 14.0228 14.2223 13.6293 14.6673 13.6293Z'
      fill='#3F3F46'
    />
    <path
      d='M1.33269 13.6293C1.77773 13.6293 2.13392 14.0229 2.13392 14.5172C2.13392 15.0116 1.7777 15.4073 1.33269 15.4073C0.88766 15.4073 0.53348 15.0116 0.53348 14.5172C0.53348 14.0228 0.887782 13.6293 1.33269 13.6293Z'
      fill='#3F3F46'
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.8942 9.99687L13.1769 5.62444C13.2624 4.3006 12.2118 3.1798 10.8852 3.17981H5.19427C3.82569 3.1798 2.74116 4.33497 2.82738 5.70083L3.09817 9.99011C3.20828 11.7343 3.26334 12.6064 3.71974 13.2335C3.94538 13.5436 4.23609 13.8053 4.57333 14.002C5.25547 14.3998 6.16911 14.3998 7.9964 14.3998C9.82129 14.3998 10.7337 14.3998 11.4154 14.0027C11.7524 13.8064 12.043 13.5451 12.2688 13.2356C12.7253 12.6095 12.7816 11.7386 12.8942 9.99687Z'
      fill='#3F3F46'
    />
    <path
      d='M12.8942 9.99687L13.493 10.0356L12.8942 9.99687ZM3.09817 9.99011L2.49936 10.0279L3.09817 9.99011ZM12.2688 13.2356L12.7536 13.5891L12.2688 13.2356ZM11.4154 14.0027L11.1134 13.4843H11.1134L11.4154 14.0027ZM3.71974 13.2335L4.20487 12.8804L3.71974 13.2335ZM4.57333 14.002L4.27105 14.5202H4.27105L4.57333 14.002ZM1.60156 2.5798C1.27019 2.5798 1.00156 2.84843 1.00156 3.1798C1.00156 3.51118 1.27019 3.7798 1.60156 3.7798V3.1798V2.5798ZM14.4016 3.7798C14.7329 3.7798 15.0016 3.51118 15.0016 3.1798C15.0016 2.84843 14.7329 2.5798 14.4016 2.5798V3.1798V3.7798ZM10.3997 2.22218L10.9349 1.95089L10.9349 1.95088L10.3997 2.22218ZM5.62498 2.27626L5.08337 2.01808L5.08337 2.01808L5.62498 2.27626ZM5.19427 3.17981L4.65266 2.92163L4.24358 3.77981H5.19427V3.17981ZM6.37782 1.08076L6.02292 0.596977V0.596978L6.37782 1.08076ZM6.57579 0.959006L6.30384 0.424173V0.424173L6.57579 0.959006ZM9.63785 1.06963L9.98625 0.581145L9.98625 0.581144L9.63785 1.06963ZM9.44252 0.952601L9.17587 1.49009L9.17587 1.49009L9.44252 0.952601ZM5.62448 10.6601C5.62448 10.9915 5.89311 11.2601 6.22448 11.2601C6.55585 11.2601 6.82448 10.9915 6.82448 10.6601H6.22448H5.62448ZM6.82448 6.58014C6.82448 6.24877 6.55585 5.98014 6.22448 5.98014C5.89311 5.98014 5.62448 6.24877 5.62448 6.58014H6.22448L6.82448 6.58014ZM9.17865 10.6601C9.17865 10.9915 9.44728 11.2601 9.77865 11.2601C10.11 11.2601 10.3786 10.9915 10.3786 10.6601H9.77865H9.17865ZM10.3786 6.58014C10.3786 6.24877 10.11 5.98014 9.77865 5.98014C9.44728 5.98014 9.17865 6.24877 9.17865 6.58014H9.77865H10.3786ZM12.8942 9.99687L13.493 10.0356L13.7756 5.66315L13.1769 5.62444L12.5781 5.58574L12.2955 9.95816L12.8942 9.99687ZM2.82738 5.70083L2.22858 5.73863L2.49936 10.0279L3.09817 9.99011L3.69698 9.9523L3.42619 5.66302L2.82738 5.70083ZM12.8942 9.99687L12.2955 9.95816C12.2384 10.8412 12.1977 11.4592 12.1186 11.9364C12.0412 12.4027 11.9354 12.6743 11.784 12.882L12.2688 13.2356L12.7536 13.5891C13.0586 13.1707 13.2093 12.6939 13.3024 12.1328C13.3936 11.5826 13.4374 10.8943 13.493 10.0356L12.8942 9.99687ZM7.9964 14.3998V14.9998C8.89769 14.9998 9.61421 15.0004 10.1894 14.9477C10.7732 14.8941 11.2698 14.7819 11.7174 14.5211L11.4154 14.0027L11.1134 13.4843C10.8793 13.6206 10.5789 13.7069 10.0798 13.7527C9.57214 13.7992 8.92001 13.7998 7.9964 13.7998V14.3998ZM12.2688 13.2356L11.784 12.882C11.608 13.1233 11.3801 13.3289 11.1134 13.4843L11.4154 14.0027L11.7174 14.5211C12.1248 14.2838 12.4781 13.9669 12.7536 13.5891L12.2688 13.2356ZM3.09817 9.99011L2.49936 10.0279C2.55365 10.8878 2.59646 11.5771 2.68705 12.128C2.77942 12.6899 2.9296 13.1675 3.23461 13.5866L3.71974 13.2335L4.20487 12.8804C4.05347 12.6724 3.94793 12.4004 3.87115 11.9334C3.79258 11.4555 3.7528 10.8365 3.69698 9.9523L3.09817 9.99011ZM7.9964 14.3998V13.7998C7.07159 13.7998 6.41857 13.7992 5.91025 13.7526C5.41053 13.7067 5.10984 13.6203 4.87562 13.4837L4.57333 14.002L4.27105 14.5202C4.71896 14.7815 5.21616 14.8939 5.80062 14.9476C6.37648 15.0004 7.09393 14.9998 7.9964 14.9998V14.3998ZM3.71974 13.2335L3.23461 13.5866C3.51001 13.965 3.86341 14.2825 4.27105 14.5202L4.57333 14.002L4.87562 13.4837C4.60876 13.328 4.38075 13.1221 4.20487 12.8804L3.71974 13.2335ZM1.60156 3.1798V3.7798H14.4016V3.1798V2.5798H1.60156V3.1798ZM10.3997 2.22218L9.86453 2.49347L10.35 3.4511L10.8852 3.17981L11.4203 2.90851L10.9349 1.95089L10.3997 2.22218ZM5.62498 2.27626L5.08337 2.01808L4.65266 2.92163L5.19427 3.17981L5.73588 3.43798L6.16659 2.53444L5.62498 2.27626ZM5.62498 2.27626L6.16659 2.53444C6.32849 2.19481 6.43291 1.97715 6.52902 1.81606C6.61878 1.66562 6.67914 1.60385 6.73273 1.56454L6.37782 1.08076L6.02292 0.596978C5.79515 0.764071 5.63625 0.970347 5.49851 1.20121C5.36712 1.42142 5.2358 1.69831 5.08337 2.01808L5.62498 2.27626ZM8.02563 0.799805V0.199805C7.65703 0.199805 7.34249 0.19928 7.0819 0.221966C6.81089 0.245558 6.55411 0.296922 6.30384 0.424173L6.57579 0.959006L6.84773 1.49384C6.91057 1.46189 6.9998 1.43365 7.18597 1.41744C7.38258 1.40033 7.63641 1.3998 8.02563 1.3998V0.799805ZM6.37782 1.08076L6.73273 1.56454C6.76869 1.53816 6.80714 1.51448 6.84773 1.49384L6.57579 0.959006L6.30384 0.424173C6.20565 0.4741 6.11167 0.531868 6.02292 0.596977L6.37782 1.08076ZM10.3997 2.22218L10.9349 1.95088C10.7785 1.64242 10.6437 1.37519 10.5103 1.16277C10.3705 0.940051 10.2111 0.741525 9.98625 0.581145L9.63785 1.06963L9.28946 1.55812C9.34272 1.59611 9.40299 1.65579 9.49396 1.80073C9.5914 1.95596 9.69843 2.16582 9.86453 2.49347L10.3997 2.22218ZM8.02563 0.799805V1.3998C8.40538 1.3998 8.65279 1.40031 8.84468 1.41672C9.02627 1.43225 9.11385 1.45932 9.17587 1.49009L9.44252 0.952601L9.70917 0.415111C9.4632 0.293082 9.21197 0.243754 8.94693 0.221087C8.69219 0.199299 8.38516 0.199805 8.02563 0.199805V0.799805ZM9.63785 1.06963L9.98625 0.581144C9.89849 0.518551 9.80581 0.463054 9.70917 0.415111L9.44252 0.952601L9.17587 1.49009C9.21586 1.50993 9.25384 1.53271 9.28946 1.55812L9.63785 1.06963ZM6.22448 10.6601H6.82448V6.58014L6.22448 6.58014H5.62448L5.62448 10.6601H6.22448ZM9.77865 10.6601H10.3786V6.58014H9.77865H9.17865V10.6601H9.77865ZM10.8852 3.17981V2.57981H5.19427V3.17981V3.77981H10.8852V3.17981ZM2.82738 5.70083L3.42619 5.66302C3.36178 4.64272 4.17193 3.7798 5.19427 3.77981V3.17981L5.19427 2.57981C3.47945 2.5798 2.12053 4.02722 2.22858 5.73863L2.82738 5.70083ZM13.1769 5.62444L13.7756 5.66315C13.8836 3.99343 12.5584 2.5798 10.8852 2.57981V3.17981L10.8852 3.77981C11.8652 3.7798 12.6413 4.60777 12.5781 5.58574L13.1769 5.62444Z'
      fill='#3F3F46'
    />
  </svg>
);

export const DuplicateIcon = () => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M12 7C12 6.337 11.7365 5.701 11.268 5.232C10.799 4.7635 10.163 4.5 9.5 4.5C8.0115 4.5 5.9885 4.5 4.5 4.5C3.837 4.5 3.201 4.7635 2.732 5.232C2.2635 5.701 2 6.337 2 7C2 8.4885 2 10.5115 2 12C2 12.663 2.2635 13.299 2.732 13.768C3.201 14.2365 3.837 14.5 4.5 14.5C5.9885 14.5 8.0115 14.5 9.5 14.5C10.163 14.5 10.799 14.2365 11.268 13.768C11.7365 13.299 12 12.663 12 12V7Z'
      fill='#3F3F46'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M5.05078 3.5H9.50028C10.4288 3.5 11.3188 3.8685 11.9753 4.525C12.6318 5.1815 13.0003 6.0715 13.0003 7V11.4495C13.4768 11.352 13.9188 11.117 14.2683 10.768C14.7368 10.299 15.0003 9.663 15.0003 9C15.0003 7.5115 15.0003 5.4885 15.0003 4C15.0003 3.337 14.7368 2.701 14.2683 2.232C13.7993 1.7635 13.1633 1.5 12.5003 1.5C11.0118 1.5 8.98878 1.5 7.50028 1.5C6.83728 1.5 6.20128 1.7635 5.73228 2.232C5.38328 2.5815 5.14828 3.0235 5.05078 3.5Z'
      fill='#3F3F46'
    />
  </svg>
);

export const LinkIcon = () => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.79203 0.333984H4.20536C1.7787 0.333984 0.332031 1.78065 0.332031 4.20732V9.78732C0.332031 12.2207 1.7787 13.6673 4.20536 13.6673H9.78536C12.212 13.6673 13.6587 12.2207 13.6587 9.79398V4.20732C13.6654 1.78065 12.2187 0.333984 9.79203 0.333984ZM4.45203 10.1807C4.4387 10.1807 4.4187 10.1807 4.40536 10.1807C3.7587 10.1207 3.15203 9.82065 2.6987 9.34065C1.63203 8.22065 1.63203 6.40065 2.6987 5.28065L4.1587 3.74732C4.6787 3.20065 5.3787 2.89398 6.12536 2.89398C6.87203 2.89398 7.57203 3.19398 8.09203 3.74732C9.1587 4.86732 9.1587 6.68732 8.09203 7.80732L7.36536 8.57398C7.17203 8.77398 6.8587 8.78065 6.6587 8.59398C6.4587 8.40065 6.45203 8.08732 6.6387 7.88732L7.36536 7.12065C8.07203 6.38065 8.07203 5.17398 7.36536 4.44065C6.70536 3.74732 5.54536 3.74732 4.8787 4.44065L3.4187 5.97398C2.71203 6.71398 2.71203 7.92065 3.4187 8.65398C3.70536 8.96065 4.09203 9.14732 4.4987 9.18732C4.77203 9.21398 4.97203 9.46065 4.94536 9.73398C4.92536 9.98732 4.70536 10.1807 4.45203 10.1807ZM11.2987 8.72732L9.8387 10.2606C9.3187 10.8073 8.6187 11.114 7.87203 11.114C7.12536 11.114 6.42536 10.814 5.90536 10.2606C4.8387 9.14065 4.8387 7.32065 5.90536 6.20065L6.63203 5.43398C6.82536 5.23398 7.1387 5.22732 7.3387 5.41398C7.5387 5.60732 7.54536 5.92065 7.3587 6.12065L6.63203 6.88732C5.92536 7.62732 5.92536 8.83398 6.63203 9.56732C7.29203 10.2607 8.45203 10.2673 9.1187 9.56732L10.5787 8.03398C11.2854 7.29398 11.2854 6.08732 10.5787 5.35398C10.292 5.04732 9.90536 4.86065 9.4987 4.82065C9.22536 4.79398 9.02536 4.54732 9.05203 4.27398C9.0787 4.00065 9.3187 3.79398 9.5987 3.82732C10.2454 3.89398 10.852 4.18732 11.3054 4.66732C12.3654 5.78065 12.3654 7.60732 11.2987 8.72732Z'
      fill='#3F3F46'
    />
  </svg>
);

export const POIIcon = () => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.6667 12.658L14.3631 13.0974C14.0032 13.2173 13.7153 13.4969 13.5953 13.8644L13.1555 15.1667C12.7796 16.2933 11.196 16.2693 10.8441 15.1428L9.36451 10.3889C9.07659 9.44617 9.94835 8.56732 10.8841 8.86293L15.6508 10.341C16.7704 10.6926 16.7864 12.2825 15.6667 12.658Z'
      fill='#3F3F46'
    />
    <path
      d='M15.6984 7.59278C15.6984 7.93633 15.6744 8.27989 15.6344 8.61545C15.6024 8.85514 15.3545 8.99895 15.1226 8.92704L11.2437 7.72061C10.824 7.59042 10.3769 7.57667 9.94999 7.68081C9.52313 7.78495 9.13265 8.00308 8.82033 8.31184C8.18051 8.95101 7.94858 9.8858 8.2205 10.7487L9.42016 14.6077C9.49214 14.8393 9.34019 15.087 9.10025 15.119C8.76435 15.1589 8.43644 15.1829 8.10053 15.1829C3.82973 15.1829 0.39069 11.6755 0.502659 7.37706C0.614627 3.41422 3.9177 0.11451 7.88459 0.00265595C12.1874 -0.109198 15.6984 3.32633 15.6984 7.59278Z'
      fill='#3F3F46'
    />
  </svg>
);

export const TextureIcon = () => (
  <svg
    width='17'
    height='16'
    viewBox='0 0 17 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.48 4.93975L11.12 4.13309C11.32 4.03309 11.3733 3.77309 11.22 3.61309C10.6267 2.95975 10.0267 2.41309 9.54667 1.99975C9.32667 1.81309 9 1.96642 9 2.25309V4.63975C9 4.88642 9.26 5.04642 9.48 4.93975Z'
      fill='#3F3F46'
    />
    <path
      d='M9 13.1602V14.2602C9 14.4602 9.18 14.6269 9.38 14.5936C11.2 14.2936 12.72 13.0736 13.44 11.4336C13.5667 11.1536 13.26 10.8736 12.98 11.0069L9.18667 12.8669C9.07333 12.9202 9 13.0336 9 13.1602Z'
      fill='#3F3F46'
    />
    <path
      d='M8.00161 2.23975C8.00161 1.95309 7.67494 1.79975 7.45494 1.97975C5.88161 3.29975 3.08828 6.07975 3.10161 9.26642C3.10161 11.9464 5.06161 14.1664 7.62161 14.5931C7.82161 14.6264 8.00161 14.4598 8.00161 14.2598V2.23975Z'
      fill='#3F3F46'
    />
    <path
      d='M9.45885 8.3133L12.9855 6.8333C13.1655 6.7533 13.2522 6.54663 13.1655 6.3733C12.9189 5.88663 12.6322 5.4133 12.3189 4.9733C12.2255 4.83996 12.0522 4.79996 11.9055 4.86663L9.17885 6.1933C9.06552 6.24663 8.99219 6.36663 8.99219 6.4933V8.00663C8.99885 8.23996 9.23885 8.40663 9.45885 8.3133Z'
      fill='#3F3F46'
    />
    <path
      d='M13.72 9.53981C13.8267 9.48648 13.8933 9.38648 13.8933 9.27315C13.8933 8.84648 13.84 8.42648 13.7467 8.01315C13.7 7.81315 13.48 7.70648 13.2933 7.78648L9.2 9.53315C9.08 9.58648 9 9.70648 9 9.83981V11.3065C9 11.5531 9.26 11.7131 9.48 11.6065L13.4133 9.69315L13.72 9.53981Z'
      fill='#3F3F46'
    />
  </svg>
);

export const LightIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9 21H15'
      stroke='#3F3F46'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 21V14L14 7V21'
      stroke='#3F3F46'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 3V5'
      stroke='#3F3F46'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18 5L16.5 6.5'
      stroke='#3F3F46'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 5L7.5 6.5'
      stroke='#3F3F46'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const ShaderIcon = () => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M2 2L14 2C14.5523 2 15 2.44772 15 3L15 13C15 13.5523 14.5523 14 14 14L2 14C1.44772 14 1 13.5523 1 13L1 3C1 2.44772 1.44772 2 2 2Z'
      stroke='#3F3F46'
      strokeWidth='1.5'
      fill='none'
    />
    <path
      d='M4 6L12 6'
      stroke='#3F3F46'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M4 8L10 8'
      stroke='#3F3F46'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M4 10L8 10'
      stroke='#3F3F46'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <circle cx='12' cy='9' r='2' fill='#3F3F46' />
  </svg>
);

export const SnapToGridIcon = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.3955 19.4594C12.2792 19.5753 12.1203 19.6484 11.9372 19.6483C11.5832 19.648 11.2912 19.3549 11.2924 19.0009L11.3501 1.91197C11.3513 1.55799 11.6452 1.26524 11.9992 1.2655C12.3532 1.26575 12.6452 1.55891 12.644 1.91289L12.5863 19.0018C12.5857 19.1849 12.5119 19.3435 12.3955 19.4594Z'
      fill='#3F3F46'
    />
    <path
      d='M18.6847 13.1958L12.3955 19.4594C12.1445 19.7094 11.7295 19.7091 11.4801 19.4587L5.23324 13.1863C4.98386 12.9359 4.98526 12.5209 5.23633 12.2708C5.48741 12.0208 5.90243 12.021 6.15181 12.2715L11.9425 18.0858L17.7723 12.2797C18.0234 12.0296 18.4384 12.0299 18.6878 12.2803C18.9372 12.5308 18.9358 12.9458 18.6847 13.1958Z'
      fill='#3F3F46'
    />
    <path
      d='M20.5 22.75H3.5C3.09 22.75 2.75 22.41 2.75 22C2.75 21.59 3.09 21.25 3.5 21.25H20.5C20.91 21.25 21.25 21.59 21.25 22C21.25 22.41 20.91 22.75 20.5 22.75Z'
      fill='#3F3F46'
    />
  </svg>
);

export const EventIcon = () => {
  return (
    <svg
      width='14'
      height='19'
      viewBox='0 0 14 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.32905 18.4575C5.16239 18.4575 5.02905 18.4242 4.92905 18.3825C4.59572 18.2575 4.02905 17.8492 4.02905 16.5575V11.1825H2.07905C0.962386 11.1825 0.562386 10.6575 0.420719 10.3492C0.279052 10.0325 0.154052 9.39088 0.887386 8.54921L7.19572 1.38255C8.04572 0.415878 8.73739 0.482545 9.07072 0.607545C9.40405 0.732545 9.97072 1.14088 9.97072 2.43254V7.80755H11.9207C13.0374 7.80755 13.4374 8.33255 13.5791 8.64088C13.7207 8.95755 13.8457 9.59921 13.1124 10.4409L6.80405 17.6075C6.21239 18.2825 5.69572 18.4575 5.32905 18.4575ZM8.61239 1.78255C8.58739 1.81588 8.41239 1.89921 8.13739 2.21588L1.82905 9.38254C1.59572 9.64921 1.56239 9.81588 1.56239 9.84921C1.57905 9.85754 1.72905 9.94088 2.07905 9.94088H4.65405C4.99572 9.94088 5.27905 10.2242 5.27905 10.5659V16.5659C5.27905 16.9825 5.35405 17.1659 5.38739 17.2159C5.41239 17.1825 5.58739 17.0992 5.86239 16.7825L12.1707 9.61588C12.4041 9.34921 12.4374 9.18254 12.4374 9.14921C12.4207 9.14088 12.2707 9.05755 11.9207 9.05755H9.34572C9.00405 9.05755 8.72072 8.77421 8.72072 8.43255V2.43254C8.72905 2.01588 8.64572 1.84088 8.61239 1.78255Z'
        fill='#A1A1AA'
      />
    </svg>
  );
};

export const ConditionIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.0099 10.6836C16.6683 10.6836 16.3849 10.4003 16.3849 10.0586V7.29199C16.3849 6.25866 15.5433 5.41699 14.5099 5.41699H2.97656C2.6349 5.41699 2.35156 5.13366 2.35156 4.79199C2.35156 4.45033 2.6349 4.16699 2.97656 4.16699H14.5099C16.2349 4.16699 17.6349 5.56699 17.6349 7.29199V10.0586C17.6349 10.4086 17.3516 10.6836 17.0099 10.6836Z'
        fill='#A1A1AA'
      />
      <path
        d='M5.6099 8.05856C5.45157 8.05856 5.29323 8.0002 5.16823 7.8752L2.5349 5.24189C2.41823 5.12522 2.35156 4.96686 2.35156 4.8002C2.35156 4.63353 2.41823 4.47522 2.5349 4.35856L5.16823 1.7252C5.4099 1.48353 5.8099 1.48353 6.05156 1.7252C6.29323 1.96686 6.29323 2.36691 6.05156 2.60858L3.85992 4.8002L6.05156 6.99187C6.29323 7.23354 6.29323 7.63353 6.05156 7.8752C5.92656 7.99187 5.76823 8.05856 5.6099 8.05856Z'
        fill='#A1A1AA'
      />
      <path
        d='M17.0099 16.8253H5.47656C3.75156 16.8253 2.35156 15.4253 2.35156 13.7003V10.9336C2.35156 10.5919 2.6349 10.3086 2.97656 10.3086C3.31823 10.3086 3.60156 10.5919 3.60156 10.9336V13.7003C3.60156 14.7336 4.44323 15.5753 5.47656 15.5753H17.0099C17.3516 15.5753 17.6349 15.8586 17.6349 16.2003C17.6349 16.5419 17.3516 16.8253 17.0099 16.8253Z'
        fill='#A1A1AA'
      />
      <path
        d='M14.3807 19.4579C14.2224 19.4579 14.0641 19.3996 13.9391 19.2746C13.6974 19.0329 13.6974 18.6329 13.9391 18.3912L16.1307 16.1996L13.9391 14.0079C13.6974 13.7663 13.6974 13.3663 13.9391 13.1246C14.1807 12.8829 14.5807 12.8829 14.8224 13.1246L17.4557 15.7579C17.5724 15.8746 17.6391 16.0329 17.6391 16.1996C17.6391 16.3663 17.5724 16.5246 17.4557 16.6413L14.8224 19.2746C14.7057 19.3996 14.5474 19.4579 14.3807 19.4579Z'
        fill='#A1A1AA'
      />
    </svg>
  );
};

export const ActionIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0005 19.3577C9.44219 19.3577 8.87552 19.2327 8.43385 18.9743L3.85052 16.3327C1.98385 15.0743 1.86719 14.8827 1.86719 12.9077V8.09101C1.86719 6.11601 1.97552 5.92435 3.80885 4.68268L8.42552 2.01602C9.30052 1.50768 10.6755 1.50768 11.5505 2.01602L16.1505 4.66602C18.0172 5.92435 18.1339 6.11601 18.1339 8.09101V12.8993C18.1339 14.8743 18.0255 15.066 16.1922 16.3077L11.5755 18.9743C11.1255 19.2327 10.5589 19.3577 10.0005 19.3577ZM10.0005 2.89102C9.65052 2.89102 9.30885 2.95768 9.06719 3.09935L4.48385 5.74935C3.12552 6.66602 3.12552 6.66602 3.12552 8.09101V12.8993C3.12552 14.3243 3.12552 14.3243 4.51719 15.266L9.06719 17.891C9.55885 18.1744 10.4505 18.1744 10.9422 17.891L15.5255 15.241C16.8755 14.3243 16.8755 14.3243 16.8755 12.8993V8.09101C16.8755 6.66602 16.8755 6.66602 15.4839 5.72435L10.9339 3.09935C10.6922 2.95768 10.3505 2.89102 10.0005 2.89102Z'
        fill='#A1A1AA'
      />
      <path
        d='M10 13.625C8.275 13.625 6.875 12.225 6.875 10.5C6.875 8.775 8.275 7.375 10 7.375C11.725 7.375 13.125 8.775 13.125 10.5C13.125 12.225 11.725 13.625 10 13.625ZM10 8.625C8.96667 8.625 8.125 9.46667 8.125 10.5C8.125 11.5333 8.96667 12.375 10 12.375C11.0333 12.375 11.875 11.5333 11.875 10.5C11.875 9.46667 11.0333 8.625 10 8.625Z'
        fill='#A1A1AA'
      />
    </svg>
  );
};

export const TargetIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3ZM1.25 10.5C1.25 5.66751 5.16751 1.75 10 1.75C14.8325 1.75 18.75 5.66751 18.75 10.5C18.75 15.3325 14.8325 19.25 10 19.25C5.16751 19.25 1.25 15.3325 1.25 10.5Z'
        fill='#A1A1AA'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 7.375C8.27411 7.375 6.875 8.77411 6.875 10.5C6.875 12.2259 8.27411 13.625 10 13.625C11.7259 13.625 13.125 12.2259 13.125 10.5C13.125 8.77411 11.7259 7.375 10 7.375ZM5.625 10.5C5.625 8.08375 7.58375 6.125 10 6.125C12.4162 6.125 14.375 8.08375 14.375 10.5C14.375 12.9162 12.4162 14.875 10 14.875C7.58375 14.875 5.625 12.9162 5.625 10.5Z'
        fill='#A1A1AA'
      />
      <path
        d='M10 11.75C10.6904 11.75 11.25 11.1904 11.25 10.5C11.25 9.80964 10.6904 9.25 10 9.25C9.30964 9.25 8.75 9.80964 8.75 10.5C8.75 11.1904 9.30964 11.75 10 11.75Z'
        fill='#A1A1AA'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 7.375C8.27411 7.375 6.875 8.77411 6.875 10.5C6.875 12.2259 8.27411 13.625 10 13.625C11.7259 13.625 13.125 12.2259 13.125 10.5C13.125 8.77411 11.7259 7.375 10 7.375ZM5.625 10.5C5.625 8.08375 7.58375 6.125 10 6.125C12.4162 6.125 14.375 8.08375 14.375 10.5C14.375 12.9162 12.4162 14.875 10 14.875C7.58375 14.875 5.625 12.9162 5.625 10.5Z'
        fill='#A1A1AA'
      />
      <path
        d='M10 11.75C10.6904 11.75 11.25 11.1904 11.25 10.5C11.25 9.80964 10.6904 9.25 10 9.25C9.30964 9.25 8.75 9.80964 8.75 10.5C8.75 11.1904 9.30964 11.75 10 11.75Z'
        fill='#A1A1AA'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 7.375C8.27411 7.375 6.875 8.77411 6.875 10.5C6.875 12.2259 8.27411 13.625 10 13.625C11.7259 13.625 13.125 12.2259 13.125 10.5C13.125 8.77411 11.7259 7.375 10 7.375ZM5.625 10.5C5.625 8.08375 7.58375 6.125 10 6.125C12.4162 6.125 14.375 8.08375 14.375 10.5C14.375 12.9162 12.4162 14.875 10 14.875C7.58375 14.875 5.625 12.9162 5.625 10.5Z'
        fill='#A1A1AA'
      />
      <path
        d='M10 11.75C10.6904 11.75 11.25 11.1904 11.25 10.5C11.25 9.80964 10.6904 9.25 10 9.25C9.30964 9.25 8.75 9.80964 8.75 10.5C8.75 11.1904 9.30964 11.75 10 11.75Z'
        fill='#A1A1AA'
      />
      <path
        d='M15.4375 10.5C15.4375 7.49695 13.003 5.0625 10 5.0625C6.99695 5.0625 4.5625 7.49695 4.5625 10.5C4.5625 13.503 6.99695 15.9375 10 15.9375V17.1875C6.3066 17.1875 3.3125 14.1934 3.3125 10.5C3.3125 6.8066 6.3066 3.8125 10 3.8125C13.6934 3.8125 16.6875 6.8066 16.6875 10.5C16.6875 14.1934 13.6934 17.1875 10 17.1875V15.9375C13.003 15.9375 15.4375 13.503 15.4375 10.5Z'
        fill='#A1A1AA'
      />
    </svg>
  );
};

export const EventLinkIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.4146 12.7917H8.33125C7.98959 12.7917 7.70625 12.5083 7.70625 12.1667C7.70625 11.825 7.98959 11.5417 8.33125 11.5417H10.4146C12.5979 11.5417 14.3729 9.76667 14.3729 7.58333C14.3729 5.4 12.5979 3.625 10.4146 3.625H6.24792C4.06459 3.625 2.28959 5.4 2.28959 7.58333C2.28959 8.5 2.61458 9.39166 3.19792 10.1C3.41458 10.3667 3.38125 10.7583 3.11458 10.9833C2.84792 11.2 2.45625 11.1667 2.23125 10.9C1.45625 9.96668 1.03125 8.79167 1.03125 7.58333C1.03125 4.70833 3.36458 2.375 6.23958 2.375H10.4062C13.2813 2.375 15.6146 4.70833 15.6146 7.58333C15.6146 10.4583 13.2896 12.7917 10.4146 12.7917Z'
        fill='#A1A1AA'
      />
      <path
        d='M13.75 18.6257H9.58333C6.70833 18.6257 4.375 16.2923 4.375 13.4173C4.375 10.5423 6.70833 8.20898 9.58333 8.20898H11.6667C12.0083 8.20898 12.2917 8.49232 12.2917 8.83398C12.2917 9.17565 12.0083 9.45898 11.6667 9.45898H9.58333C7.4 9.45898 5.625 11.234 5.625 13.4173C5.625 15.6007 7.4 17.3757 9.58333 17.3757H13.75C15.9333 17.3757 17.7083 15.6007 17.7083 13.4173C17.7083 12.5007 17.3833 11.609 16.8 10.9007C16.5833 10.634 16.6167 10.2423 16.8833 10.0173C17.15 9.79233 17.5417 9.83398 17.7667 10.1006C18.5417 11.034 18.9667 12.209 18.9667 13.4173C18.9583 16.2923 16.625 18.6257 13.75 18.6257Z'
        fill='#A1A1AA'
      />
    </svg>
  );
};

export const QuestIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99479 10.7087C9.62812 10.7087 9.26146 10.617 8.92812 10.442L3.50313 7.51699C3.01146 7.25033 2.70312 6.72533 2.70312 6.14199C2.70312 5.55866 3.01146 5.03366 3.50313 4.76699L8.92812 1.84199C9.59479 1.48366 10.3948 1.48366 11.0531 1.84199L16.4781 4.76699C16.9698 5.03366 17.2781 5.55866 17.2781 6.14199C17.2781 6.72533 16.9698 7.25033 16.4781 7.51699L11.0531 10.442C10.7281 10.6253 10.3615 10.7087 9.99479 10.7087ZM9.99479 2.81699C9.83646 2.81699 9.66979 2.85866 9.51979 2.94199L4.10312 5.85866C3.96146 5.93366 3.95312 6.09199 3.95312 6.14199C3.95312 6.19199 3.96146 6.35033 4.10312 6.41699L9.52812 9.34199C9.82812 9.50032 10.1698 9.50032 10.4698 9.34199L15.8948 6.41699C16.0281 6.34199 16.0448 6.18366 16.0448 6.14199C16.0448 6.09199 16.0365 5.93366 15.8948 5.86699L10.4698 2.94199C10.3198 2.85866 10.1531 2.81699 9.99479 2.81699Z'
        fill='#A1A1AA'
      />
      <path
        d='M8.15521 19.4338C7.92188 19.4338 7.68021 19.3755 7.46354 19.2671L2.41354 16.7505C1.57188 16.3255 1.04688 15.4755 1.04688 14.5338V9.76712C1.04688 9.22546 1.32188 8.73379 1.78021 8.45046C2.24688 8.16712 2.80521 8.14212 3.28854 8.38379L8.33854 10.9005C9.18021 11.3255 9.70521 12.1671 9.70521 13.1171V17.8838C9.70521 18.4255 9.43021 18.9171 8.97188 19.2005C8.72188 19.3588 8.43854 19.4338 8.15521 19.4338ZM2.59688 9.46712C2.53021 9.46712 2.47188 9.49213 2.43854 9.50879C2.38854 9.54213 2.29688 9.61712 2.29688 9.76712V14.5338C2.29688 15.0005 2.55521 15.4255 2.97188 15.6338L8.01354 18.1588C8.14688 18.2255 8.25521 18.1755 8.30521 18.1505C8.35521 18.1171 8.44688 18.0421 8.44688 17.8921V13.1255C8.44688 12.6588 8.18854 12.2338 7.77188 12.0255L2.73021 9.50046C2.68021 9.47546 2.63854 9.46712 2.59688 9.46712Z'
        fill='#A1A1AA'
      />
      <path
        d='M11.8547 19.4333C11.5714 19.4333 11.288 19.3583 11.038 19.2C10.5797 18.9167 10.3047 18.425 10.3047 17.8833V13.1167C10.3047 12.175 10.8297 11.325 11.6714 10.9L16.713 8.375C17.1964 8.13334 17.763 8.15834 18.2214 8.44167C18.6797 8.725 18.9547 9.21667 18.9547 9.75834V14.525C18.9547 15.4667 18.4297 16.3167 17.588 16.7417L12.5464 19.2667C12.3297 19.3833 12.088 19.4333 11.8547 19.4333ZM17.413 9.46667C17.3714 9.46667 17.3297 9.475 17.2797 9.5L12.238 12.025C11.8214 12.2333 11.563 12.65 11.563 13.125V17.8917C11.563 18.0417 11.6547 18.1167 11.7047 18.15C11.7547 18.1833 11.863 18.225 11.9964 18.1583L17.038 15.6333C17.4547 15.425 17.713 15 17.713 14.5333V9.76667C17.713 9.61667 17.6214 9.54167 17.5714 9.50834C17.538 9.49167 17.4797 9.46667 17.413 9.46667Z'
        fill='#A1A1AA'
      />
    </svg>
  );
};

export const CollectibleIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99351 19.3341C9.06851 19.3341 8.21017 18.9424 7.5685 18.2424L1.85184 11.9591C1.0435 11.0758 0.793501 9.51745 1.27683 8.42578L3.41018 3.62578C3.99351 2.31745 4.96851 1.67578 6.40184 1.67578H13.5602V2.30078V1.67578C14.9935 1.67578 15.9685 2.30912 16.5518 3.61745L18.6852 8.41745C19.1685 9.50912 18.9268 11.0674 18.1185 11.9508L12.4102 18.2424C11.7852 18.9424 10.9185 19.3341 9.99351 19.3341ZM13.5685 2.91745H6.41017C5.3185 2.91745 4.87684 3.40078 4.56017 4.12578L2.42684 8.92578C2.14351 9.56745 2.31017 10.5924 2.77684 11.1091L8.4935 17.3924C8.8935 17.8341 9.42684 18.0758 9.99351 18.0758C10.5602 18.0758 11.0935 17.8341 11.4935 17.3924L17.2018 11.1008C17.6768 10.5758 17.8435 9.55911 17.5518 8.91745L15.4185 4.11745C15.1018 3.40078 14.6602 2.91745 13.5685 2.91745Z'
        fill='#A1A1AA'
      />
      <path
        d='M2.92188 7.79251C2.58021 7.79251 2.29688 7.50918 2.29688 7.16751C2.29688 6.82584 2.58021 6.54251 2.92188 6.54251L17.0885 6.53418C17.4302 6.53418 17.7135 6.81751 17.7135 7.15918C17.7135 7.50085 17.4302 7.78418 17.0885 7.78418L2.92188 7.79251Z'
        fill='#A1A1AA'
      />
      <path
        d='M8.82031 2.80078L7.53906 7.30273L6.28906 6.94727L7.57031 2.44531L8.82031 2.80078Z'
        fill='#A1A1AA'
      />
      <path
        d='M13.6514 7.12012L10.8809 18.7275L10.249 18.5771L9.61719 18.4258L12.3867 6.81738L13.6514 7.12012Z'
        fill='#A1A1AA'
      />
      <path
        d='M6.17676 7.12012L8.94727 18.7275L9.5791 18.5771L10.2109 18.4258L7.44141 6.81738L6.17676 7.12012Z'
        fill='#A1A1AA'
      />
      <path
        d='M11.0078 2.80078L12.2891 7.30273L13.5391 6.94727L12.2578 2.44531L11.0078 2.80078Z'
        fill='#A1A1AA'
      />
    </svg>
  );
};

export const DestroyableIcon = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 2.5L12.5 7.5L17.5 8.5L14 12.5L14.5 17.5L10 15L5.5 17.5L6 12.5L2.5 8.5L7.5 7.5L10 2.5Z'
        stroke='#A1A1AA'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <path
        d='M10 6V10.5'
        stroke='#A1A1AA'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M10 13V14'
        stroke='#A1A1AA'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <circle cx='6' cy='8' r='0.5' fill='#A1A1AA' />
      <circle cx='14' cy='8' r='0.5' fill='#A1A1AA' />
      <circle cx='8' cy='15' r='0.5' fill='#A1A1AA' />
      <circle cx='12' cy='15' r='0.5' fill='#A1A1AA' />
    </svg>
  );
};
